import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  Alert,
  TouchableOpacity,
  Image,
  ScrollView,
  StatusBar,
  Pressable,
  Platform,
} from "react-native";
import styles from "../../../styles/profileStyle";
import { useNavigation } from "@react-navigation/native";
import { SafeAreaView } from "react-native-safe-area-context";

import {
  updateData,
  updateDataImage,
} from "../../../../../services/Profile/profileService";
import { PROFILE_ROUTES } from "../../../../../navigation/routes";
import TopIconView from "../../../../Auth/components/TopIconView";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import AuthIcons from "../../../../../assets/Icons/AuthIcons";
import ProfileIcons from "../../../../../assets/Icons/FeedIcons/ProfileIcons";
import { getAllexperience } from "../../../../../services/Experience/experienceService";
import { handleBackButton } from "../../../components/BackButtonAlert";
import { useBackButtonHandler } from "../../../hooks/useBackHandler";
import { Colors } from "../../../../../globalStyles/ColorConfig";
import ExperienceAlert from "../../../../../modal/OnBoardingModal/ExperienceAlert";
import { TouchableWithoutFeedback } from "react-native-gesture-handler";

type Experience = {
  _id: string; // Change the type according to your data structure
  title: string;
  media: {
    images: {
      url: string;
    }[];
  };
};

const SelectExperienceOnboarding = () => {
  // const navigation = useNavigation();
  const navigation = useNavigation();
  useBackButtonHandler(handleBackButton, [navigation]);

  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const [image3, setImage3] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);

  function uploadButtonHandle(id: any) {
    if (image1 == id) {
      setImage1(image2);
      setImage2(image3);
      setImage3(null);
    } else if (image2 == id) {
      setImage2(image3);
      setImage3(null);
    } else if (image3 == id) {
      setImage3(null);
    } else if (image1 == null) {
      setImage1(id);
    } else if (image2 == null) {
      setImage2(id);
    } else if (image3 == null) {
      setImage3(id);
    } else {
      setAlertOpen(true);
    }
  }
  const findcount = (id: any) => {
    if (id == image1) {
      return 1;
    } else if (id == image2) {
      return 2;
    } else if (id == image3) {
      return 3;
    }
  };
  const handleSubmitButton = async () => {
    // console.log("asfd");
    const exprienceData: any[] = [
      { id: image1 },
      { id: image2 },
      { id: image3 },
    ];
    // console.log(exprienceData);
    if (
      exprienceData[0] == null ||
      exprienceData[1] == null ||
      exprienceData[2] == null
    ) {
      Alert.alert("please select 3 image");
    } else {
      const response = await updateDataImage({
        interestedExperiences: exprienceData,
        steps: 5,
      });
      const res2 = await updateData({
        interestedExperiences: exprienceData,
        steps: 5,
      });
      navigation.navigate(PROFILE_ROUTES.COMPANY_ADD as never);
    }
  };

  const [data, setData] = useState<null | { experiences: Experience[] }>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllexperience();
        setData(response?.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  return (
    <SafeAreaView
      style={{
        height: "100%",
        backgroundColor: "#fff",
      }}
    >
      <ScrollView
        style={{
          height: Platform.OS === "web" ? 300 : "100%",
          backgroundColor: "#fff",
          paddingHorizontal: 16,
          paddingTop: 30,
        }}
        contentContainerStyle={{
          paddingBottom: 50,
        }}
        showsVerticalScrollIndicator={false}
      >
        <TopIconView
          icon={<ProfileIcons.DiamondIcon />}
          totalScreens={4}
          currentScreen={4}
        />
        <Text
          style={[
            styles.imageBoxHead,
            GlobalStyles.heading3,
            {
              fontFamily: "EBGaramondSemiBold",
              fontSize: 33,
              lineHeight: 33,
              letterSpacing: -0.4,
              marginTop: 10,
            },
          ]}
        >
          Select experience that describes your perfect date
        </Text>
        <Text
          style={[
            GlobalStyles.captionText,
            {
              marginTop: 3,
              marginBottom: 15,
              fontFamily: "InterMedium",
              fontSize: 15,

              letterSpacing: -0.4,
              opacity: 0.45,
            },
          ]}
        >
          Choose up to 3 experiences
        </Text>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            flexWrap: "wrap",
            gap: 14
          }}
        >
          {data?.experiences?.map((item, index) => {
            return (
              <>
                {image1 == item?._id ||
                image2 == item?._id ||
                image3 == item?._id ? (
                  <>
                    <Pressable
                      onPress={() => uploadButtonHandle(item?._id)}
                      style={{
                        width: "47.5%",
                        // marginBottom: 10,
                      }}
                      key={index}
                    >
                      <Image
                        source={{ uri: item?.media?.images[0]?.url }}
                        style={{
                          width: "100%",
                          height: 160,
                          borderRadius: 10,
                        }}
                        blurRadius={6}
                      />
                      <Text
                        style={[
                          GlobalStyles.black90,
                          GlobalStyles.captionText,
                          {
                            fontSize: 18,
                            color: "rgba(0,0,0,0.7)",
                            marginTop: 4,
                            fontFamily: "EBGaramondSemiBold",
                            letterSpacing: -0.4,
                            lineHeight: 20,
                          },
                        ]}
                        numberOfLines={2}
                      >
                        {item?.title}
                      </Text>
                      <View style={styles.blurBoxText}>
                        <Text style={styles.blurText}>
                          {findcount(item?._id)}
                        </Text>
                      </View>
                    </Pressable>
                  </>
                ) : (
                  <>
                    <Pressable
                      onPress={() => uploadButtonHandle(item?._id)}
                      style={{
                        width: "47.5%",
                      }}
                      key={index}
                    >
                      <Image
                        source={{ uri: item?.media?.images[0]?.url }}
                        style={{
                          width: "100%",
                          height: 160,
                          borderRadius: 10,
                        }}
                      />
                      <Text
                        style={[
                          GlobalStyles.black60,
                          GlobalStyles.captionText,
                          {
                            fontSize: 18,
                            color: "rgba(0,0,0,0.7)",
                            marginTop: 4,
                            fontFamily: "EBGaramondSemiBold",
                            letterSpacing: -0.4,
                            lineHeight: 20,
                          },
                        ]}
                        numberOfLines={2}
                      >
                        {item?.title}
                      </Text>
                    </Pressable>
                  </>
                )}
              </>
            );
          })}
        </View>
      </ScrollView>
      <View
        style={{
          position: "absolute",
          bottom: 30,
          right: 20,
        }}
      >
        <TouchableWithoutFeedback
          onPress={image1 && image2 && image3 ? handleSubmitButton : () => {}}
          style={{
            // opacity:
            // dec  the opacity if 3 exp have been selected
            opacity: image1 && image2 && image3 ? 1 : 0.2,
          }}
        >
          <AuthIcons.AuthArrow />
        </TouchableWithoutFeedback>
      </View>
    </SafeAreaView>
  );
};

export default SelectExperienceOnboarding;
